import { xeroGetters } from '@/store/modules/xero/routines'

export default {
  [xeroGetters.VALIDATION_STATE_CODE]: state => state.validationStateCode,
  [xeroGetters.ONBOARDING_DATA]: state => state.onboardingData,
  [xeroGetters.XERO_ORIGIN]: state => state.xeroOrigin,
  [xeroGetters.IS_XERO_LOGIN]: state => state.isXeroLogin
}
